const DEFAULT_APP_ROUTE = '/app/courses';

export function getSafeReturnTo(
  value: string | null | undefined,
  fallback = DEFAULT_APP_ROUTE,
): string {
  const target = value?.trim();

  if (!target || !target.startsWith('/') || target.startsWith('//')) {
    return fallback;
  }

  if (
    target === '/login' ||
    target.startsWith('/login?') ||
    target === '/signup' ||
    target.startsWith('/signup?') ||
    target === '/profile/setup' ||
    target.startsWith('/profile/setup?')
  ) {
    return fallback;
  }

  return target;
}

export function withReturnTo(path: string, returnTo: string): string {
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}returnTo=${encodeURIComponent(returnTo)}`;
}
